import { File } from './../../models/files/files.model';

export class Grant {
    id?: string;
    title?: any;
    content?: any;
    files: Array<File>;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.content = options.content;
        this.files = options.files;
    }
}
